import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Home2 from "./Home2";
import Type from "./Type";
import BlackholeBackground from "../BlackholeBackground";

function Home() {
  return (
    <section style={{ position: "relative" }}>
      <div className="hero-blackhole-wrap">
        <BlackholeBackground />
      </div>
      <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'm
                <strong className="main-name"> Aman Kumar Dewangan (AkD)</strong>
              </h1>

              <h5 className="heading-name6">
                currently working as 
                <strong className="main-name">  Software Developer at GE Healthcare.</strong>
              </h5>

              <div style={{ padding: 50, textAlign: "left", color:"#00e8ba" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
      </Container>

      <Home2 />
    </section>
  );
}

export default Home;
